import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import Media from "@qlik/qlik/src/components/Media";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getCardBodyContent, renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import * as styles from "./styles.module.css";

/**
 * HeroBannerLargeFrame component.
 * Renders a section with a title, CTA, and media.
 * @param {Object} data - The data for the component.
 * @param {Object} data.cardItem - The card item data.
 */
const HeroBannerLargeFrame = ({ data }) => {
    const { cardItem, customId } = data || {};
    const { title, eyebrowText, cta, media } = cardItem || {};

    const sectionSpacingClassName = getSpacingClassName(data.additionalConfiguration);
    const bodyContent = getCardBodyContent(cardItem);
    return (
        <section className={`${sectionSpacingClassName} overflow-hidden ${styles.bannerLarge}`} id={customId}>
            <div className="container">
                <div className="row">
                    <div className="col-12 md:col-6 pt-10 md:pt-20 lg:pt-25 lg:pb-25 md:pb-20.5 relative z-2 flex flex-col justify-center">
                        {eyebrowText && (
                            <p
                                className=" text-center  tracking-[3.5px] md:text-left text-sm md:text-base font-medium  md:tracking-wide5 leading-none md:leading-tight mb-3.75  md:mb-3 text-ocean uppercase"
                                // eslint-disable-next-line react/no-danger
                                dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(eyebrowText) }}
                            />
                        )}
                        <h1
                            className="text-center md:text-left title-2 text-with-color mb-3.75 md:mb-7.5"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                        />
                        {/* Rendering the body if it exists */}
                        {bodyContent && <div className={`${styles.bodyContent}`}>{bodyContent}</div>}

                        {/* Rendering the CTA if it exists */}
                        {cta?.length > 0 && (
                            <div className="mb-7.5 flex-col md:flex-row items-center md:items-start md:mb-0 justify-center md:justify-start sm:mt-5 flex md:flex-wrap gap-y-5 md:gap-y-0 md:gap-x-5">
                                {cta?.map((button) => (
                                    <Cta key={button.id} data={button} className="mt-5" />
                                ))}
                            </div>
                        )}
                    </div>
                    {/* Rendering the media if it exists */}
                    {((media?.[0]?.desktopMedia?.length || media?.[0]?.mobileMedia?.length) > 0 ||
                        media?.[0]?.videoExternalUrl) && (
                        <div className="col-12 md:col-6 relative">
                            <div className="relative w-full h-full">
                                <Media
                                    options={{ loop: false }}
                                    media={media[0]}
                                    videoClassName="md:object-cover w-full h-90 lg:h-[450px] xl:h-137.5 relative"
                                    className="object-cover object-left max-w-none w-full h-auto md:h-[450px] md:w-[calc(100%+200px)] lg:h-[520px] lg:w-[calc(100%+300px)] xl:w-[calc(100%+440px)] xl:h-[720px]"
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default HeroBannerLargeFrame;
